module.exports = __webpack_public_path__ + "static/media/diktat-3.01f8db07.mp3";